// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM7.64574 9.54082C8.50589 8.02163 10.1345 7 12.0004 7H13.0004V5H12.0004C9.385 5 7.10601 6.4348 5.90534 8.55543L5.41264 9.42563L7.15305 10.411L7.64574 9.54082ZM7.00391 13.2091L7.00402 11.1329L5.00402 11.1328L5.00391 13.209L7.00391 13.2091Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-highlight-1-filled')
export default class Highlight1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'highlight-1-filled',
    }
  }
}
